if (!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
    constructor() {
      super();
    }

    handleChange(event) {
      if (event.target.getAttribute('type') != 'radio') return;

      this.propertyInput.value = event.target.value;

      const label = this.querySelector('[data-label]');
      if (label) label.textContent = event.target.value;
    }

    connectedCallback() {
      this.propertyInput = this.querySelector('[js-dropdown-input]');
      this.addEventListener('change', this.handleChange.bind(this));
    }
  }

  customElements.define('product-dropdown', ProductDropdown);
}
